import type { PositionKind } from "../api/structure";
import { usePositionKinds } from "../lib/usePositionKinds";
import { LocationKindIcon } from "./LocationKindIcon";

/**
 * Icon of a position kind, resolved through the admin codebook (sprint 5e):
 * the kind row carries the icon key, the palette is shared with location kinds.
 * Falls back to a box for an unknown / deleted kind.
 */
export function PositionKindIcon({ kind }: { kind: PositionKind }) {
  const { iconOf } = usePositionKinds();
  return <LocationKindIcon icon={iconOf(kind)} />;
}

/** The kind's colour dot (admin-chosen); renders nothing when the kind has no colour. */
export function PositionKindDot({ kind }: { kind: PositionKind }) {
  const { colorOf, labelOf } = usePositionKinds();
  const color = colorOf(kind);
  if (!color) return null;
  return <span className="kind-dot" style={{ background: color }} title={labelOf(kind)} aria-hidden="true" />;
}

/** Display name of a position kind (codebook name, seeded fallback, or the code itself). */
export function PositionKindName({ kind }: { kind: PositionKind }) {
  const { labelOf } = usePositionKinds();
  return <>{labelOf(kind)}</>;
}
